module.exports = __webpack_public_path__ + "static/media/IconRewardsInactive.06b3c476.svg";